import React from 'react';
import {useIntl} from '@sail/intl';
import {useRichTextKey} from 'mkt-ssr/lib/intl';
import {
  Section,
  RowLayout,
  ColumnLayout,
  Copy,
  HelmIcon,
  AreaChart,
  Blocks,
  GlobeWithMoney,
  Platform,
} from '@sail/helm';
import {Link, css} from '@sail/ui';
import {useLinkResolver} from 'mkt-ssr/lib/routing/LinkResolver';
import * as messages from 'mkt-ssr/components/sail/pages/StartupPartners/WhyStripeSection.messages';

export const WhyStripeSection = () => {
  const intl = useIntl();
  const getKey = useRichTextKey();
  const {createRoute} = useLinkResolver();

  return (
    <Section theme="dark" flavor="chroma" accent="cyan">
      <RowLayout gap="xlarge">
        <Copy
          variant="section"
          caption={intl.formatMessage(messages.sectionCaption)}
          title={intl.formatMessage(messages.sectionTitle)}
          subviews={{
            title: {
              uses: [
                css({
                  textWrap: 'pretty',
                }),
              ],
            },
          }}
        />
        <ColumnLayout>
          <Copy
            icon={<HelmIcon icon={Blocks} />}
            variant="detail"
            title={intl.formatMessage(messages.getStartedTitle)}
            body={intl.formatMessage(messages.getStartedBody, {
              paymentLinksLink: (chunks) => (
                <Link
                  key={getKey()}
                  href={createRoute(
                    'https://stripe.com/payments/payment-links',
                  )}
                >
                  {chunks}
                </Link>
              ),
              invoicingLink: (chunks) => (
                <Link
                  key={getKey()}
                  href={createRoute('https://stripe.com/invoicing')}
                >
                  {chunks}
                </Link>
              ),
            })}
          />
          <Copy
            icon={<HelmIcon icon={AreaChart} />}
            variant="detail"
            title={intl.formatMessage(messages.growBusinessTitle)}
            body={intl.formatMessage(messages.growBusinessBody)}
          />
          <Copy
            icon={<HelmIcon icon={GlobeWithMoney} />}
            variant="detail"
            title={intl.formatMessage(messages.globalBenefitTitle)}
            body={intl.formatMessage(messages.globalBenefitDescription)}
          />
          <Copy
            icon={<HelmIcon icon={Platform} />}
            variant="detail"
            title={intl.formatMessage(messages.suiteBenefitTitle)}
            body={intl.formatMessage(messages.suiteBenefitDescription, {
              RadarLink: (chunks) => (
                <Link
                  key={getKey()}
                  href={createRoute('https://stripe.com/radar')}
                >
                  {chunks}
                </Link>
              ),
              TaxLink: (chunks) => (
                <Link
                  key={getKey()}
                  href={createRoute('https://stripe.com/tax')}
                >
                  {chunks}
                </Link>
              ),
              IdentityLink: (chunks) => (
                <Link
                  key={getKey()}
                  href={createRoute('https://stripe.com/identity')}
                >
                  {chunks}
                </Link>
              ),
              SigmaLink: (chunks) => (
                <Link
                  key="sigma"
                  href={createRoute('https://stripe.com/sigma')}
                >
                  {chunks}
                </Link>
              ),
            })}
          />
        </ColumnLayout>
      </RowLayout>
    </Section>
  );
};
